/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Qr_TitleInputs */

const vi_grower_qr_title = /** @type {(inputs: Grower_Qr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR số điện thoại hộ`)
};

/**

* @param {Grower_Qr_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_qr_title = /** @type {((inputs?: Grower_Qr_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Qr_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_qr_title(inputs)
});